export const getDuplicatedTitle = (
  title: string,
  existingTitles: string[],
): string => {
  if (!existingTitles.includes(title)) {
    return title;
  }

  // Find all existing names that match the pattern "Title (n)"
  const baseName = title.trim();
  const pattern = new RegExp(
    `^${baseName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")} \\((\\d+)\\)$`,
  );

  const existingNumbers = existingTitles
    .map((name) => {
      const match = name.match(pattern);
      return match ? parseInt(match[1], 10) : null;
    })
    .filter((num): num is number => num !== null)
    .sort((a, b) => a - b);

  let nextNumber = 1;
  for (const num of existingNumbers) {
    if (num === nextNumber) {
      nextNumber += 1;
    } else {
      break;
    }
  }

  return `${baseName} (${nextNumber})`;
};
